/**
 * What "filtered" means on the customer map.
 *
 * The map's filter bar offers five ways to narrow the set — one group, the four
 * site statuses, alarm categories, relay load types and a search box — and the
 * rest of the page has to agree on what "clear all"
 * resets, so a cleared map shows every site again without also repainting its
 * markers or reordering its list. This module owns that, plus the display
 * vocabulary the status chips are labelled and coloured from.
 *
 * Contains:
 * - STATUS_META — the four status toggles, worst-first, with their palette family
 * - CLEARED_FILTERS — what "clear all" resets, and what it deliberately leaves
 *
 * Returns plain JS — no JSX, no redux.
 */
import { SITE_STATUS } from '@sophocles/features/map/mapState';
import { SITE_STATUS_LABEL } from '@sophocles/views/map/mapStatusLabels';

/**
 * The four status toggles in worst-first order, each with the semantic status
 * family (cssTokens.js `--status-*`) its chip is tinted from and the map's
 * shared label for that status.
 */
export const STATUS_META = Object.freeze([
  Object.freeze({ status: SITE_STATUS.ALARMING, family: 'bad', label: SITE_STATUS_LABEL[SITE_STATUS.ALARMING] }),
  Object.freeze({ status: SITE_STATUS.OFFLINE, family: 'warning', label: SITE_STATUS_LABEL[SITE_STATUS.OFFLINE] }),
  Object.freeze({ status: SITE_STATUS.SILENT, family: 'neutral', label: SITE_STATUS_LABEL[SITE_STATUS.SILENT] }),
  Object.freeze({ status: SITE_STATUS.ONLINE, family: 'ok', label: SITE_STATUS_LABEL[SITE_STATUS.ONLINE] }),
]);

/**
 * The patch "clear all" writes — every narrowing dimension back to unset.
 * `list`, `color`, `sort` and `bbox` change how the same set is presented, so
 * they are not filters and clearing leaves them alone.
 */
export const CLEARED_FILTERS = Object.freeze({
  group: null,
  status: Object.freeze([]),
  cat: Object.freeze([]),
  lt: Object.freeze([]),
  q: '',
});
